import { setUserLogin, setUserName } from '../Account/actions'
import * as ApiBase from '../APIBase'
import { loadingMerchant } from '../Header/actions'
import { getCookieToken } from '../utils/cookieToken'

export const checkUserLogin = (merchantName) => async (dispatch, getState) => {
  const subPath = merchantName || getState().merchant.canonical_name
  const URL = `/${subPath}/customer/check_login`
  const accessToken = getCookieToken() || getState().user.accessToken
  if (accessToken) {
    const response = await ApiBase.get(URL, {}, accessToken)
    dispatch(setUserLogin(response.success))
    dispatch(loadingMerchant(false))
    dispatch(setUserName(response.first_name))
  }
  return null
}
